import { Trans, TransProps } from 'react-i18next';
import { Platform } from 'react-native';
import { Li } from '@/common/components/DOM/DOM';
import { Label } from '@/common/components/Label/Label';
import { ParseKeys } from 'i18next';
import { BodyText, TBodyTextProps } from '../BodyText/BodyText';

export type TTranslateProps = Omit<TransProps<ParseKeys>, 'size'> & {
  className?: string;
  size?: TBodyTextProps['size'];
  color?: TBodyTextProps['color'];
};

export function Translate({
  size,
  color,
  className,
  ...props
}: TTranslateProps) {
  const textProps: TBodyTextProps = Object.fromEntries(
    Object.entries({ size, color, className }).filter(
      ([_, value]) => value !== undefined
    )
  );

  const TextComponent = props.parent === Label ? Label : BodyText;

  return (
    <Trans
      {...props}
      size={props.parent ? size : undefined}
      color={props.parent ? color : undefined}
      components={{
        strong: <TextComponent bold as="strong" {...textProps} />,
        br: Platform.OS === 'web' ? <br /> : <>{'\n'}</>,
        a: <TextComponent as="a" {...textProps} />,
        li: <Li {...textProps} />,
        ...props.components,
      }}
    />
  );
}
